import React, { useEffect, useState } from "react";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import SnackBarMessage from "../../components/SnackBarMessage";
import { updateOne, addItem } from '../repositories/StudyTypeRepository';
import { Button, Grid, InputLabel, TextField, CircularProgress, MenuItem } from '@mui/material';

const StatusForm = ({ name, item, isEditing, statusData, add }) => {
    const [buttonText, setButtonText] = useState("Guardar");
    const [loading, setLoading] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);
    const [snackSeverity, setSnackSeverity] = useState("success");
    const [snackMessage, setSnackMessage] = useState("");

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: '',
            status: '',
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required('Campo obligatorio'),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            const studyExist = item?._id || null;
            if (!studyExist) {
                formik.setFieldValue('name', ' ');
            }
            try {
                let response;
                if (studyExist) {
                    response = await updateOne(studyExist, values);
                } else {
                    response = await addItem(values);
                }
                setLoading(false);
                if (response.status === 'Ok') {
                    setSnackSeverity("success");
                    setSnackMessage(studyExist ? "Actualizado correctamente" : "Agregado correctamente");
                    setSnackOpen(true);
                } else {
                    throw new Error(response.message);
                }
            } catch (error) {
                setLoading(false);
                setSnackSeverity("error");
                setSnackMessage(error?.response?.data?.message);
                setSnackOpen(true);
            }
        },
    });

    useEffect(() => {
        if (isEditing !== null) {
            formik.setValues({
                name: name,
                status: item.status,
            });
        }
    }, []);

    const handleSnackClose = () => {
        setSnackOpen(false);
    };

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2} direction="column" style={{ marginTop: '15px', marginBottom: '20px' }}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12} marginLeft={3} marginRight={3}>
                    <InputLabel shrink>Nombre</InputLabel>
                    <TextField
                        type="text"
                        id="name"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={isEditing}
                        size="small"
                        inputProps={{ style: { fontSize: 14 } }}
                        fullWidth
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name && formik.errors.name}
                    />
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12} marginLeft={3} marginRight={3}>
                    <InputLabel shrink>Estatus</InputLabel>
                    <TextField
                        select
                        id="status"
                        name="status"
                        value={formik.values.status}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        disabled={add}
                        size="small"
                        inputProps={{ style: { fontSize: 14 } }}
                        fullWidth
                    >
                        {statusData.map((item) => (
                            <MenuItem key={item.id} value={item.name}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    {loading ? (
                        <CircularProgress />
                    ) : (

                        <Button
                            id="button-style-save-reception-form"
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={!formik.dirty}
                        >
                            {buttonText}
                        </Button>
                    )}
                </Grid>
            </Grid>
            <SnackBarMessage
                open={snackOpen}
                severity={snackSeverity}
                message={snackMessage}
                setOpen={setSnackOpen}
                onClose={handleSnackClose}
            />
        </form>
    );
};

export default StatusForm;
